module.exports = require('./helpers/bundle-url').getBundleURL('7VwIV') + "default_left.dfc31853.svg";